import LargeResourcePreview from 'components/Utils/LargeResourcePreview';
import { api } from 'careand-redux/api/ApiThunks';
import DefaultModal from 'components/Utils/DefaultModal';
import React, { useState } from 'react';
import { useAppDispatch } from 'careand-redux/useAppDispatch';

const ReceiptModal = ({ receipt, patient, open, onClose, buttons }) => {
  const dispatch = useAppDispatch();
  return (
    open && (
      <DefaultModal
        className="large-modal receipt-modal"
        key="add-document-modal"
        title="Receipt"
        wrap={true}
        padding={false}
        content={
          <>
            <LargeResourcePreview
              key={receipt?.id}
              autoLoad={true}
              getFile={(dispatchOptions) =>
                dispatch(
                  api.Invoices.getReceiptPdf({
                    patientId: patient?.id,
                    receiptId: receipt.id,
                  }),
                  dispatchOptions,
                )
              }
            />
            {buttons && <div className="buttons">{buttons}</div>}
          </>
        }
        isOpen={open}
        onRequestClose={onClose}
      />
    )
  );
};

export default ReceiptModal;
